"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Content = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var styled_components_1 = __importDefault(require("styled-components"));
var content_types_1 = require("./content-types");
var Article = styled_components_1.default.article(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n\n  &.media {\n    margin: 0 auto;\n  }\n"], ["\n  display: flex;\n  justify-content: center;\n\n  &.media {\n    margin: 0 auto;\n  }\n"])));
var MediaTypes = {
    'image': function (data) { return ((0, jsx_runtime_1.jsx)(content_types_1.ContentImage, { data: data })); },
    'video': function (data) { return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {})); },
    'embed': function () { return ((0, jsx_runtime_1.jsx)("p", { children: "un embed por aqu\u00ED" })); },
};
var ContentsTypes = {
    'text': function (data) { return ((0, jsx_runtime_1.jsx)(content_types_1.ContentText, { data: data })); },
    'media': function (data) { return (MediaTypes[data.media.type](data)); },
    'empty': function () { return ((0, jsx_runtime_1.jsx)("div", { className: 'empty' })); },
    'spacer': function () { return ((0, jsx_runtime_1.jsx)("div", { className: 'spacer' })); }
};
var getContentByType = function (content) {
    var type = content.type;
    if (!type || !ContentsTypes[type])
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    return (ContentsTypes[type](content));
};
var Content = function (_a) {
    var content = _a.content;
    var ContentByType = (0, react_1.useMemo)(function () { return getContentByType(content); }, [content]);
    return ((0, jsx_runtime_1.jsx)(Article, __assign({ className: content.type }, { children: ContentByType })));
};
exports.Content = Content;
var templateObject_1;
